import { render, staticRenderFns } from "./MessagesModal.vue?vue&type=template&id=ad05545c&"
import script from "./MessagesModal.vue?vue&type=script&lang=js&"
export * from "./MessagesModal.vue?vue&type=script&lang=js&"
import style0 from "./MessagesModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports